import { render } from "./Numbers.vue?vue&type=template&id=1c949534"
import script from "./Numbers.vue?vue&type=script&lang=js"
export * from "./Numbers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__